import { Injectable } from '@angular/core';
import { SalesByProductsPrintingQuery, SalesByProductsPrintingQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SalesByProductsPrintingQuery)
@Wrapper(SalesByProductsPrintingQueryHandlerBase)
export class SalesByProductsPrintingQueryHandler {
    public constructor(
        http: Http
    ) { }
}
